export default "__VITE_ASSET__7dEV1lZv__"